import axios from "axios";
import {API_DOMAIN} from "../constants";

export async function getRetailLocations(
    page,
    size,
    params
) {
    const includeInactive = params.active !== true;
    const inactiveOnly = params.active === false;

    const response = await axios({
        url: API_DOMAIN + "/api/v2/retailLocations",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            page: page,
            size: size,
            ...params,
        },
    });

    return {retailLocations: response.data, totalCount: parseInt(response.headers["x-total-count"])};
}

export async function getRetailLocation(id) {
    const response = await axios({
        url: API_DOMAIN + `/api/v2/retailLocations/${id}`,
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return response.data;
}

export async function updateRetailLocation(payload) {
    return axios({
        url: API_DOMAIN + "/api/v2/retailLocations",
        method: "PUT",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });
}

export async function createRetailLocation(payload) {
    return axios({
        url: API_DOMAIN + "/api/v2/retailLocations",
        method: "POST",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });
}

export async function getSelectFitEbsCodes(params) {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/retailLocations/selectFitEbsCodes",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params,
    });

    return {selectFitEbsCodes: response.data};
}

export async function getSelectFitCategories(params) {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/retailLocations/selectFitCategories",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params,
    });

    return {selectFitCategories: response.data};
}

export async function getSelectFitLogoTypes(params) {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/retailLocations/selectFitLogoTypes",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params,
    });

    return {selectFitLogoTypes: response.data};
}

export async function getRetailLocationsToCSV(params) {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/retailLocations/adminPortal/csv",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        responseType: "blob",
        params: {
            ...params,
        },
    });

    return response;
}

export async function uploadRetailLocationsFile(file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios({
        url: API_DOMAIN + "/api/v2/retailLocations/upload",
        method: "POST",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
            "Content-Type": "multipart/form-data",
        },
        data: formData,
    });

    return response.data;
}
export async function validateUploadRetailLocationsFile(file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios({
        url: API_DOMAIN + "/api/v2/retailLocations/validateUpload",
        method: "POST",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
            "Content-Type": "multipart/form-data",
        },
        data: formData,
    });

    return response;
}
